module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@2x-fe2cecc29fe2cc53072a5eec5ea8b561.png";